import React, { useRef, useState, useEffect, useContext } from 'react'
import classNames from 'classnames'

import BLOCKS from 'shared/constants/blocks'

import { BlockComponents, NAVIGATION_TYPES } from '../constants'

import EditorContext from '../contexts/editorContext'

import InlineControls from './components/Controls/Inline/Inline'

import { getIsMultiplayerBlock } from 'utils/multiplayer'

const BlocksController = ({ pages, isMultiplayerGame, block, appData, isSelected, isLast, isFirst, methods }) => {
    const editorContext = useContext(EditorContext)
    const [Component] = useState(() => BlockComponents[block.t])
    const [isHovered, setIsHovered] = useState(false)
    const inlineControlsRef = useRef()

    const [isCanClone, setIsCanClone] = useState(true)
    const [isCanRemove, setIsCanRemove] = useState(true)

    useEffect(() => {
        const isMultiplayerOverflow = isMultiplayerGame && getIsMultiplayerBlock(block)
        const isAuthFormBlock = block.t === BLOCKS.authForm
        const isStartPageTimer = block.t === BLOCKS.countdown && editorContext.navigationType === NAVIGATION_TYPES.START

        if (isMultiplayerOverflow || isAuthFormBlock || isStartPageTimer) {
            setIsCanClone(false)
        } else {
            setIsCanClone(true)
        }

        if (isAuthFormBlock || isStartPageTimer) {
            setIsCanRemove(false)
        } else {
            setIsCanRemove(true)
        }
    }, [isMultiplayerGame, block])

    if (!Component) return null

    return (
        <div
            className={classNames('block-control', { __selected: isSelected })}
            data-id={block.id}
            onClick={evt => {
                evt.stopPropagation()
                const isInlineControlsClick = inlineControlsRef.current.contains(evt.target)
                if (!isInlineControlsClick) methods.onBlockSelect(block)
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="selected-border" />
            <Component
                {...block} // TODO пока оставил чтобы не ломалось, но надо перенести логику в блоках > 9 на "blockData.<KEY>"
                blockData={block}
                appData={appData}
                pagesData={pages}
                onUpdate={_data => methods.changeBlocksData(_data)}
                requestArrayElementControls={methods.requestArrayElementControls}
                selected={isSelected}
            />
            <div
                className="plus"
                onClick={evt => {
                    methods.onOpenBlockPanel(block.id)
                    evt.stopPropagation()
                }}
            />
            <InlineControls
                inlineControlsRef={inlineControlsRef}
                isHideClone={!isCanClone}
                isHideDelete={!isCanRemove}
                isVisible={isSelected || isHovered}
                firstElement={isFirst}
                lastElement={isLast}
                onAction={methods.onInlineControlAction}
                blockId={block.id}
            />
        </div>
    )
}

export default BlocksController
